import React from 'react'
import { Table } from 'react-bootstrap';

const CartList = () => {
  return (
    <Table className="custom-employee-table" bordered hover responsive>
      <thead>
        <tr>
          <th>S.No</th>
          <th>Name</th>
          <th>Image</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        <td colSpan={4}>Replace Your Actual Table Heading And Data</td>
      </tbody>
    </Table>
  );
}

export default CartList;